import React from 'react';
import {Redirect} from 'react-router';
/*
import {
  Header,
  Segment,
  Icon,
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';
*/
//import Api from '../api';


/*
const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            content='App'
            inverted
            style={{
            fontSize: mobile ? '2em' : '4em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        />
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.7em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.apppage.header.text"/>
        </Header>
        <br/>
            <Icon name='apple' size='huge' inverted />
            <Icon name='android' size='huge' inverted />
        </Container>
    </Segment>
)*/

class UserListPage extends React.Component {

    state = {
        games: null,
    };
    _isMounted = false;

    async componentWillMount() {
        this._isMounted = true;
        
        /*
        const games = await this.fetchGames();
        const categories = await this.fetchCategories();
        games.forEach(game => game.category = categories.find(cat => cat.id === game.category).name);
        if(this._isMounted){
            this.setState({
                games
            });
        }
        */
    };

    onClick(id){
        /*
        window.dataLayer.push({
            event: 'onWebsiteEvent',
            eventCategory: 'audiobookSite',
            eventAction: 'playProject',
            eventLabel: 'clickPlay',
            eventValue: id
        });
        */
        window.scrollTo(0,0);
        this.props.history.push('/play/'+id);
    }

    render(){
        return (<Redirect to="/" />);
        /*
        return (
            <DivWrapper>
            <Segment inverted style={{border: 'none', minHeight: '200px', marginTop: '2px', borderRadius: 0}}>
            
                <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify' }}>
                <center><Icon name='wait' size='huge' />
                <br/>
                    Bald verfügbar!
                    </center>
                </Header>
                <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                  Die Liste aller öffentlichen Nutzer ist noch in der Entwicklung
                </p>
            </Segment>
            </DivWrapper>
        );
        */
    }
} 




export default UserListPage;


// WEBPACK FOOTER //
// ./src/components/UserListPage.js